<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <Row :gutter="24">
          <Col :xl="6" :lg="6" :md="0" :sm="0" :xs="0">
          <Card shadow title="使用文档" icon="md-book" :padding="0">
            <CellGroup @on-click="handleChangeCell" class="ivu-pt-8 ivu-pb-8">
              <Cell title="使用条款" name="explain1" label="授权商与极客实验室合约规范" :selected="currentType === 'explain1'" />
              <Cell title="授权流程" name="explain2" label="项目授权流程" :selected="currentType === 'explain2'" />

              <Cell title="Geek-Shop更新日志" name="explain3" label="Geek-Shop更新日志"
                :selected="currentType === 'explain3'" />

            </CellGroup>
          </Card>
          </Col>
          <Col :xl="18" :lg="18" :md="24" :sm="24" :xs="24">
          <Card :bordered="false" dis-hover>
            <Row>
              <Col :xl="0" :lg="0" :md="24" :sm="24" :xs="24">
              <Tabs :value="currentType" @on-click="handleChangeCell">
                <TabPane label="使用条款" name="explain1" />
                <TabPane label="授权流程" name="explain2" />
                <TabPane label="更新日志" name="explain3" />
                <TabPane label="审核规范" name="standard" />
              </Tabs>
              </Col>
            </Row>
            <explain1 v-if="currentType === 'explain1'" />
            <explain2 v-if="currentType === 'explain2'" />
            <explain1 v-if="currentType === 'explain3'" />
          </Card>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
  import explain1 from "./explain1";
  import explain2 from "./explain2";

  export default {
    components: {
      explain1,
      explain2
    },
    data() {
      return {
        currentType: "explain1",
      };
    },
    methods: {
      handleChangeCell(name) {
        this.currentType = name;
        if (name == 'explain3') {
          window.open("http://shop.h234.cn/timeaxis.html", "_blank", true)
        }
      },
    },
  };
</script>

<style lang="less" scoped>
  @deep: ~">>>";

  @{deep}.ivu-cell-label {
    color: #999;
  }
</style>